import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PopoverDirections, PopoverOnTop } from "../../../../Constant";
import { DIRECTION_DATA, DIRECTION_LIST } from "../../../../Data/UiKit/Popover";
import { Btn } from "../../../../AbstractElements";
import Popovers from "../../../../CommonElements/Popover";
import CommonPopover from "../Common/CommonPopover";

const PopoverDirection = () => {
  const [popover, setPopover] = useState(false);
  const toggle = () => setPopover(!popover);
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={PopoverDirections} span={DIRECTION_DATA} />
        <CardBody className="common-flex popover-wrapper">
          <Btn color="warning" className="example-popover mb-0 me-0" id="Popover-4">{PopoverOnTop}</Btn>
          <Popovers isOpen={popover} toggle={toggle} placement="top" target="Popover-4" title="Popover On Top" trigger="click">
            Popovers need the tooltip plugin considering that a dependency.
          </Popovers>
          {DIRECTION_LIST.map((data) => (
            <CommonPopover key={data.id} item={data} />
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default PopoverDirection;
